const calculateTeethCost = (teeth, serviceId) => {
	return teeth.reduce((a, b) => a + calculateToothCost(b, serviceId), 0)
}

const calculateTeethDiscount = (teeth, serviceId) => {
	return teeth.reduce((a, b) => a + calculateToothDiscount(b, serviceId), 0)
}

const calculateToothCost = (tooth, serviceId = null) => {
	let services = tooth.services || []
	if(serviceId) {
		services = services.filter(service => Number(service.id) === Number(serviceId))
	}
	return services.reduce((a, b) => a + calculateServiceCost(b), 0)
}

const calculateToothDiscount = (tooth, serviceId = null) => {
	let services = tooth.services || []
	if(serviceId) {
		services = services.filter(service => Number(service.id) === Number(serviceId))
	}
	return services.reduce((a, b) => a + calculateDiscountOfService(b), 0)
}

const calculateServiceCost = (service) => {
	const priceOriginal = Number(service.pivot?.price_original || 0)
	if(priceOriginal <= 0) return 0
	return priceOriginal - calculateDiscountOfService(service)
}

const calculateDiscountOfService = (service) => {
	const pivot = service?.pivot
	if(!pivot) return 0
	const discountType = pivot?.discount_type
	if(discountType === 'absolute') return Number(pivot.discount_absolute || 0)
	if(discountType === 'percent') return Math.round(Number((pivot.discount || 0) * (pivot.price_original || 0))) / 100
	return 0
}

const removeOneItemFromArray = (item, arr, property) => {
	if(!item || !arr || !property) return
	for(const index in arr) {
		const obj = arr[index]
		if(obj[property] === item[property]) {
			arr.splice(index, 1)
			break
		}
	}
}

export default {
	removeOneItemFromArray,
	calculateDiscountOfService,
	calculateTeethCost,
	calculateTeethDiscount,
}
